const menuLocalStorageKey = 'menu_open';

const defaultValue = true;

export const getMenuLocalStorage = () => {
    const valueLocalStorage = localStorage.getItem(menuLocalStorageKey);
    return valueLocalStorage ? Boolean(Number(valueLocalStorage)) : defaultValue;
};

export const setMenuLocalStorage = (menuOpen: boolean) => {
    if (menuOpen === defaultValue) {
        localStorage.removeItem(menuLocalStorageKey);
        return;
    }
    localStorage.setItem(menuLocalStorageKey, JSON.stringify(Number(menuOpen)));
};
